var baseApiUrl = process.env.REACT_APP_MANAGE_ISSUE_BASE_URL;
const baseurl = baseApiUrl + "api";
const baseurlforcountrywise = baseurl + "/v1/dashboard";
export const BASE_COUNTRY_URL = baseurlforcountrywise;
export const DASHBOARD_DELIVERY_FILES =BASE_COUNTRY_URL+"/getclientdatadeliveredcountchartadvancedfilters"
export const CHART_DEVIVERY=BASE_COUNTRY_URL+"/getclientdatadeliveredcountchartdaily"
export const EXPORT_DELIVERY=BASE_COUNTRY_URL+"/exportdeliveryreportdetailview"
